import ls from "localstorage-slim";
import { readGatewayAccessTokenFromBrowserStorage } from "@variphigen/shared-dashboards";
import { isJwtExpired } from "../utils/jwt";

const TOKEN_KEY = "token";

/** Delegates to package — single source of truth with shared-dashboards gateway calls. */
export function getToken(): string | null {
  const token = readGatewayAccessTokenFromBrowserStorage();
  if (!token) return null;
  if (isJwtExpired(token)) return null;
  return token;
}

/** Persist access token after login-auth redirect (compatible with shared-dashboards reader). */
export function setToken(token: string): void {
  ls.set(TOKEN_KEY, token, { encrypt: true });
  window.localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken(): void {
  ls.remove(TOKEN_KEY);
  window.localStorage.removeItem(TOKEN_KEY);
}

/** Logout / session reset — removes every key for this app origin. */
export function clearAllBrowserStorage(): void {
  try {
    ls.clear();
  } catch {
    // ignore
  }
  window.localStorage.clear();
  window.sessionStorage.clear();
}

/** @deprecated Use clearAllBrowserStorage on logout */
export function clearAuthStorage(): void {
  clearAllBrowserStorage();
}
